// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_wrapperSm__gxy5s {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Loader_wrapperMed__GLJ6Q {
  width: 100%;
  min-height: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Loader_wrapperFull__NTol9 {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 
.dot {
  background-color: #e7e0f1;
  border-radius: 50%;
  display: inline-block;
}

@keyframes spin-right {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.atom_orbit {
  width: 100%;
  height: 100%;
  position: absolute;
  -webkit-animation: spin-right 5s linear infinite;
  -moz-animation: spin-right 5s linear infinite;
  -ms-animation: spin-right 5s linear infinite;
  -o-animation: spin-right 5s linear infinite;
  animation: spin-right 5s linear infinite;
} */


.Loader_loader_container__wrH7j {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 200px;
  position: relative;
}

.Loader_pulse_loader__uSds\\+ {
  display: flex;
  gap: 10px;
}

.Loader_pulse__8vsZL {
  width: 20px;
  height: 20px;
  background-color: #883cae;
  border-radius: 50%;
  animation: Loader_pulse-animation__z0qJw 1.5s infinite ease-in-out;
}

.Loader_pulse__8vsZL:nth-child(2) {
  animation-delay: 0.3s;
  background-color: #a06dcf;
}

.Loader_pulse__8vsZL:nth-child(3) {
  animation-delay: 0.6s;
  background-color: #e7e0f1;
}

@keyframes Loader_pulse-animation__z0qJw {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.6;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Loader.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;AAGH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kEAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".wrapperSm {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wrapperMed {\n  width: 100%;\n  min-height: 20vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wrapperFull {\n  width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* \n.dot {\n  background-color: #e7e0f1;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n@keyframes spin-right {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n.atom_orbit {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  -webkit-animation: spin-right 5s linear infinite;\n  -moz-animation: spin-right 5s linear infinite;\n  -ms-animation: spin-right 5s linear infinite;\n  -o-animation: spin-right 5s linear infinite;\n  animation: spin-right 5s linear infinite;\n} */\n\n\n.loader_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 150px;\n  width: 200px;\n  position: relative;\n}\n\n.pulse_loader {\n  display: flex;\n  gap: 10px;\n}\n\n.pulse {\n  width: 20px;\n  height: 20px;\n  background-color: #883cae;\n  border-radius: 50%;\n  animation: pulse-animation 1.5s infinite ease-in-out;\n}\n\n.pulse:nth-child(2) {\n  animation-delay: 0.3s;\n  background-color: #a06dcf;\n}\n\n.pulse:nth-child(3) {\n  animation-delay: 0.6s;\n  background-color: #e7e0f1;\n}\n\n@keyframes pulse-animation {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0.6;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperSm": `Loader_wrapperSm__gxy5s`,
	"wrapperMed": `Loader_wrapperMed__GLJ6Q`,
	"wrapperFull": `Loader_wrapperFull__NTol9`,
	"loader_container": `Loader_loader_container__wrH7j`,
	"pulse_loader": `Loader_pulse_loader__uSds+`,
	"pulse": `Loader_pulse__8vsZL`,
	"pulse-animation": `Loader_pulse-animation__z0qJw`
};
export default ___CSS_LOADER_EXPORT___;
